import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, BigStat } from '../../tcn/ui-kit';
import { TCN } from '../../tcn/ui-kit/tokens';
import { formatInt, formatDiamonds } from '../shared/format';

/**
 * Module 3 — Totals header strip.
 *
 * Mirrors Module 1 HeaderStrip pattern: 4 BigStats summarizing the totals row.
 * - Total creators (sum of all tiers, excludes departed)
 * - Total diamonds MTD across all tiers
 * - Total upgrades MTD (forecasted_tier > tier_last_month)
 * - Total maintained MTD (forecasted_tier = tier_last_month, tier ≥ 1)
 *
 * Mobile  → 2x2 grid · Desktop → 1x4 row
 */
const TierTotalsHeader = ({ totals, isDesktop = false }) => {
  const { t } = useTranslation();
  if (!totals) return null;

  const stats = [
    {
      label: t('tcn.m3.totals.creators', 'Total creators'),
      value: formatInt(totals.creators_in_tier),
      color: TCN.text,
    },
    {
      label: t('tcn.m3.totals.diamondsMtd', 'Diamonds MTD'),
      value: formatDiamonds(totals.diamonds_mtd_tier_clear),
      color: TCN.diamond,
    },
    {
      label: t('tcn.m3.totals.upgrades', 'Upgrades MTD'),
      value: formatInt(totals.upgrade_actual_tier),
      color: TCN.green,
    },
    {
      label: t('tcn.m3.totals.maintained', 'Maintained MTD'),
      value: formatInt(totals.maintain_actual_tier),
      color: TCN.cyan,
    },
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
        gap: 10,
      }}
    >
      {stats.map((s, i) => (
        <Card key={i} padded style={{ padding: 14 }}>
          <BigStat label={s.label} value={s.value} color={s.color} />
        </Card>
      ))}
    </div>
  );
};

export default TierTotalsHeader;
